module.exports = __webpack_public_path__ + "img/icon-send-mew.c5044193.svg";